<template>
  <div class='p10' v-loading='tableLoading'>
    <el-table
      ref='registerTable'
      row-key='id'
      :data='tableData'
      style='width: 100%'
      border
      :header-cell-style='headerCellStyle'
    >
      <el-table-column type='index' label='序号' align='center' width='50' />
      <el-table-column v-for='item in tableOption' :key='item.prop' :prop='item.prop'
                       :label='item.label' align='center' :width='item.width || ""'
                       :formatter='item.formatter' />
    </el-table>
    <div class='paginationContainer'>
      <el-pagination
        background
        :page-sizes='[10, 20, 30, 40]'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
        @size-change='contractSizeChange'
        @current-change='contractCurrentChange'
        :current-page.sync='searchForm.page'
        :page-size='searchForm.rows'
      />
    </div>
  </div>
</template>

<script>
  import { getPageListSCFI, getPageListSOCI, getSelectInvoice } from '@/service/getData';

  export default {
    name: 'table',
    props: {
      tableOption: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        searchForm: {
          id: '',
          type: '',
          page: 1,
          rows: 10,
        },
        tableData: [],
        total: 0,
        tableLoading: false,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
      };
    },
    methods: {
      setSearchApi(type, row) {
        this.type = type;
        this.searchForm.id = row.id;
        this.searchForm.type = row.type;
        this.searchForm.page = 1;
        this.getTableData();
      },
      getTableData() {
        switch (this.type) {
          case 1:
            this.getPageListSCFI();
            break;
          case 2:
            this.getSelectInvoice();
            break;
          case 3:
            this.getPageListSOCI();
            break;
        }
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      async getPageListSOCI() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await getPageListSOCI(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      async getPageListSCFI() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await getPageListSCFI(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      async getSelectInvoice() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await getSelectInvoice(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
    },
  };
</script>

<style scoped>

</style>
